<template>
  <v-container px-0 :class="{'grid-list-md': isMobile, 'grid-list-lg': !isMobile}">
    <v-form ref="serviceInformation">
      <checkbox-list
        v-if="!isAbsent && (relevantStudentBehavior || isDisplayAll)"
        :items="sessionBehaviors"
        label="Relevant Student Behavior"
        placeholder="Select behavior(s) observed during this session."
        :validation="v.ptSessionBehaviors"
        :values="student.form.serviceInformation.ptSessionBehaviors"
        @update="(v) => student.form.serviceInformation.ptSessionBehaviors = v"
        :reset-id="isCopying" />
      <!--Objective Note-->
      <v-flex xs12 class="text-xs-right" v-if="!isAbsent && signature">
        <v-btn
          style="margin-bottom: -6px;"
          round
          slot="activator"
          color="secondary"
          @click="addObjective"
          :disabled="student.form.serviceInformation.ptSessionObjectives.length >= 3">
          <v-icon dark>mdi-plus</v-icon>
          New Objective
        </v-btn>
      </v-flex>
      <v-flex xs12 sm8 style="margin-bottom: 10px;" v-if="!isAbsent && signature">
          <h4>Objective Note</h4>
        </v-flex>
      <v-flex xs12 v-for="(item, index) in combinedArray" :key="index" v-if="!isAbsent && signature && objectivesIsProcessed">
        <objective-repeatable
          :v="v"
          :student="student"
          :sessionObjectives="sessionObjectives"
          :sessionImplementations="sessionImplementations"
          :showTooltip="showTooltip"
          :index="index"
          :record="item.ptSessionObjectives"
          :record2="item.ptSessionObjectiveImplementation"
          :isCopying="isCopying"
          @delete:record="removeObjectiveRecord(index)"
          @update:record="updateRecord(index, $event)"
          @update:record2="updateRecord2(index, $event)" >
        </objective-repeatable>
      </v-flex>
      <!-- TODO: TechDebt Register No. 1 - Add validation messages on exceed max characters -->
      <v-flex>
        <v-textarea
          v-if="objectiveNote && (!isAbsent && signature)"
          label="Objective Details"
          placeholder="Enter Objective Details"
          v-model="student.form.serviceInformation.objectiveNotes"
          v-slot="{ hasValue, isFocused }">
        </v-textarea>
      </v-flex>
      <!--Assessment of Performance / Progress-->
      <v-flex xs12 class="text-xs-right" v-if="!isAbsent && signature">
        <v-btn
          style="margin-bottom: -6px;"
          round
          slot="activator"
          color="secondary"
          @click="addTask"
          :disabled="student.form.serviceInformation.ptSessionProgresses.length >= 3">
          <v-icon dark>mdi-plus</v-icon>
          New Task
        </v-btn>
      </v-flex>
      <v-flex xs12 sm8 style="margin-bottom: 10px;" v-if="!isAbsent && signature">
          <h4>Assessment of Performance/Progress</h4>
        </v-flex>
      <v-flex xs12 v-for="(item, index) in student.form.serviceInformation.ptSessionProgresses" :key="index" v-if="!isAbsent && signature">
        <progress-repeatable
          :v="v"
          :student="student"
          :sessionAssistTypes="sessionAssistTypes"
          :showTooltip="showTooltip"
          :index="index"
          :record="item"
          :action="action"
          v-on:delete:record="removeProgressRecord(index)">
        </progress-repeatable>
      </v-flex>
      <v-flex v-if="!isAbsent && signature">
        <v-textarea
          label="Performance/Progress Notes"
          placeholder="Enter Performance/Progress Notes"
          v-model="student.form.serviceInformation.progressAssessment"
          v-slot="{ hasValue, isFocused }">
        </v-textarea>
      </v-flex>
      <!--Proposed Plan-->
      <div v-if="!isAbsent && signature">
        <v-flex xs12 sm8 style="margin-bottom: 25px;">
          <h4>Proposed Plan and Target For Upcoming Services</h4>
        </v-flex>
        <v-textarea
          label="Next Session Focus(es)"
          placeholder="Enter Next Session Focus(es)"
          v-model="student.form.serviceInformation.nextSessionFocus"
          @blur="handleTextTrimmingRequired('nextSessionFocus', student.form.serviceInformation.nextSessionFocus)"
          :error-messages="sessionFocusErrors">
        </v-textarea>

        <v-textarea
          label="Next Session Goal(s)"
          placeholder="Enter Next Session Goal(s)"
          v-model="student.form.serviceInformation.nextSessionGoal"
          @blur="handleTextTrimmingRequired('nextSessionGoal', student.form.serviceInformation.nextSessionGoal)"
          :error-messages="sessionGoalErrors">
        </v-textarea>
      </div>
      <!--Session Notes-->
      <div v-if="!isAbsent && signature">
        <v-textarea
          label="Session Notes"
          placeholder="Enter Session Notes"
          v-model="student.form.serviceInformation.sessionNotes"
          @blur="handleTextTrimming('sessionNotes', student.form.serviceInformation.sessionNotes)">
        </v-textarea>
      </div>
      <!--User Attestment-->
        <div
        v-if="action !== 'edit' && action !== 'copy' && signature">
          <v-checkbox
            id="userCheckBox"
            :disabled="providerDisabled()"
            @change="onUserCheckboxClicked"
            v-model.trim="student.form.serviceInformation.licenseAttestUserId"
            color="indigo darken-3"
            :error-messages="checkedErrors"
            :messages="checkedCreate ? this.student.form.serviceInformation.licenseAttestName + ' ' + getCurrentDate() : ''"
            :label="`Provider Signature`"
          />
        </div>
        <!--User Attestment on copy 1-->
        <div
        v-if="action === 'copy' && signature">
          <v-checkbox
            id="userCheckBoxCopy"
            :disabled="disabledCopy"
            v-model.trim="providerCheckCopy"
            @change="onUserCheckboxClickedCopy"
            color="indigo darken-3"
            :error-messages="checkedErrors"
            :key="componentKey"
            :messages="providerCheckCopy ? this.student.form.serviceInformation.licenseAttestName + ' ' + getCurrentDate() : ''"
            :label="`Provider Signature`" />
        </div>
        <!--User Attestment (edit) and provider checked off-->
        <div
        v-if="action === 'edit' && this.supervisorFlagsArray.licenseAttestName && signature">
          <v-checkbox
            id="userCheckBox"
            :disabled="providerDisabled()"
            v-model.trim="student.form.serviceInformation.licenseAttestUserId"
            @change="onUserCheckboxClicked"
            color="indigo darken-3"
            :error-messages="checkedErrors"
            :messages="!checked ? `${ this.student.form.serviceInformation.licenseAttestName ? this.student.form.serviceInformation.licenseAttestName : this.supervisorFlagsArray.licenseAttestName }` + ' ' + convertDisplayedDate(this.student.form.serviceInformation.licenseAttestDate) : ''"
            :label="`Provider Signature`" />
        </div>
        <!--User Attestment (edit) and provider has not checked off-->
        <div
        v-if="action === 'edit' && !this.supervisorFlagsArray.licenseAttestName && signature">
          <v-checkbox
            id="userCheckBox"
            :disabled="providerDisabled()"
            v-model.trim="student.form.serviceInformation.licenseAttestUserId"
            @change="onUserCheckboxClicked"
            color="indigo darken-3"
            :error-messages="checkedErrors"
            :messages="checked ? student.form.serviceInformation.licenseAttestName + ' ' + getCurrentDate() : ''"
            :label="`Provider Signature`" />
        </div>
      <!--Supervisor Attestment-->
        <div
        v-if="action === 'edit' && !this.supervisorFlagsArray.supervisorFlag && this.supervisorFlagsArray.supervisorRequiredFlag && signature">
          <v-checkbox
            id="supervisorCheckBox"
            v-model.trim="student.form.serviceInformation.supervisorUserId"
            :disabled="supervisorDisabled"
            @change="onSupervisorCheckboxClicked2"
            color="indigo darken-3"
            :error-messages="supervisorCheckedErrors"
            :messages="supervisorChecked2 ? this.student.form.serviceInformation.supervisorName + ', ' + this.student.form.serviceInformation.supervisorCredential + ' ' + getCurrentDate() : ''"
            :label="`Supervision Signature`" />
        </div>
      <!--Supervisor Attestment-->
        <div
        v-if="action === 'edit' && this.supervisorFlagsArray.supervisorFlag && this.supervisorFlagsArray.supervisorRequiredFlag && signature">
          <v-checkbox
            id="supervisorCheckBox"
            v-model.trim="student.form.serviceInformation.supervisorUserId"
            :disabled="supervisorDisabled2"
            @change="onSupervisorCheckboxClicked"
            color="indigo darken-3"
            :error-messages="supervisorCheckedErrors"
            :messages="supervisorChecked ? this.student.form.serviceInformation.supervisorName + ', ' + supervisorCredentialFill() + ' ' + calcDate() : ''"
            :label="`Supervision Signature`" />
        </div>
    </v-form>
  </v-container>
</template>

<script>
import { loadServiceAppCodes } from '@/utils/service-log-utils';
import CheckboxList from '@/components/base/checkbox-list';
import * as moment from 'moment';
import JWTHelper from '@/jwt-token';
import ObjectiveRepeatable from './objective-repeatable';
import ProgressRepeatable from './progress-repeatable';

export default {
  /* eslint-disable */
  name: 'ExtendedServiceInformation',
  components: { CheckboxList, ObjectiveRepeatable, ProgressRepeatable },
  props: {
    action: {},
    assessmentOfPerformance: {
      type: Boolean,
      required: false
    },
    arrayLength: {},
    deliveryModeArray: {
      type: Array
    },
    groupTypeArray: {},
    index: {},
    absentTypesArray: {
      type: Array
    },
    objectiveNote: {
      type: Boolean,
      required: false,
    },
    proposedPlanAndTarget: {
      type: Boolean,
      required: false,
    },
    relevantStudentBehavior: {
      type: Boolean,
      required: false
    },
    signature: {
      type: Boolean,
      required: false
    },
    showTooltip: {},
    student: {},
    supervisorFlagsArray: {},
    v: {},
    validateForm: {}
  },
  data() {
    return {
      objectivesIsProcessed: true,
      checked: false,
      checkedCreate: false,
      componentKey: 0,
      disabled: false,
      disabled2: false,
      disabledCopy: false,
      edited: false,
      providerCheckCopy: false,
      sessionBehaviors: [],
      sessionObjectives: [],
      sessionProgresses: [],
      sessionAssistTypes: [],
      sessionImplementations: [],
      saveOptions: '',
      supervisorChecked: true,
      supervisorChecked2: false
    };
  },
  computed: {
    isCopying() {
      return this.action === 'copy';
    },
    isDisplayAll() {
      return !this.relevantStudentBehavior && !this.objectiveNote && !this.assessmentOfPerformance && !this.proposedPlanAndTarget;
    },
    isEditingOrCopying() {
      return this.action === 'undefined' || this.action === 'copy';
    },
    isMobile() {
      return this.$mq === 'mobile';
    },
    combinedArray() {
      const combined = [];
      const objectives = this.student.form.serviceInformation.ptSessionObjectives;
      const implementations = this.student.form.serviceInformation.ptSessionObjectiveImplementation;

      for (const index in objectives) {
        combined.push({
          ptSessionObjectives: { ...objectives[index] },
          ptSessionObjectiveImplementation: implementations[index]
        });
      }

      /** TODO - TECH DEBT: The following code block related to `objectivesIsProcessed` is a temporary solution
       *  to the objectives repeatable component not re-rendering after processing. **/
      this.objectivesIsProcessed = false;
      this.$nextTick(() => {
        this.objectivesIsProcessed = true;
      });
      return combined;
    },
    checkedErrors() {
      const errors = [];
      const licenseAttestUserId = this.v.licenseAttestUserId;
      if (!licenseAttestUserId.$dirty) return errors;
      if (!licenseAttestUserId.required) errors.push('Provider signature is required.');
      return errors;
    },
    supervisorCheckedErrors() {
      const errors = [];
      const supervisorUserId = this.v.supervisorUserId;
      if(this.supervisorFlagsArray.canSupervise && this.supervisorFlagsArray.supervisorRequiredFlag){
        if (!supervisorUserId.$dirty) return errors;
        if (!supervisorUserId.required) errors.push('Supervisor signature is required.');
      }
      return errors;
    },
    sessionFocusErrors() {
      const errors = [];
      const sessionFocus = this.v.nextSessionFocus;
      if (!sessionFocus || !sessionFocus.$dirty) return errors;
      if (!sessionFocus.required) errors.push('Next Session Focus(es) are required.');
      return errors;
    },
    sessionGoalErrors() {
      const errors = [];
      const sessionGoal = this.v.nextSessionGoal;
      if (!sessionGoal || !sessionGoal.$dirty) return errors;
      if (!sessionGoal.required) errors.push('Next Session Goal(s) are required.');
      return errors;
    },
    supervisorDisabled(){
      // can supervise
      if (this.supervisorFlagsArray.canSupervise) {
        if (this.supervisorChecked2) {
          this.disabled2 = true;
        }
        else {
          this.disabled2 = false;
        }
      }
      // can't supervise
      else {
        this.disabled2 = true;
      }
      return this.disabled2;
    },
    supervisorDisabled2(){
      // can supervise
      if (this.supervisorFlagsArray.canSupervise) {
        if (this.supervisorChecked) {
          this.disabled = true;
        }
        else {
          this.disabled = false;
        }
      }
      // can't supervise
      else {
        this.disabled = true;
      }
      return this.disabled;
    },
    isAbsent() {
      const { absentType } = this.student.form.serviceInformation;
      return absentType === 'ABSENT_PRV' || absentType === 'ABSENT_STU';
    }
  },
  async created() {
    const APP_CODES = await loadServiceAppCodes();
    [this.sessionBehaviors, this.sessionObjectives, this.sessionProgresses, this.sessionImplementations, this.sessionAssistTypes] = APP_CODES;
  },
  mounted() {
    this.componentKey += 1;
    if (this.isCopying) {
      this.providerCheckCopy = false;
      this.student.form.serviceInformation.licenseAttestUserId = null;
      this.student.form.serviceInformation.licenseAttestDate = null;
      this.student.form.serviceInformation.licenseAttestName = null;
      this.student.form.serviceInformation.licenseAttestFlag = false;

      // Clear objective and implementation ids on copy
      this.student.form.serviceInformation.ptSessionObjectives.forEach((objective) => {
        if (objective.id) {
          objective.id = null;
          objective.ptSessionObjectiveId = null;
          objective.ptSessionId = null;
        }
      });

      this.student.form.serviceInformation.ptSessionObjectiveImplementation.forEach((implementation) => {
        implementation.id = null;
        implementation.objectiveId = null;
      });

      // Clear progress code ids on copy
      this.student.form.serviceInformation.ptSessionProgresses.forEach((progress) => {
        if (progress.id) {
          progress.id = null;
          progress.ptSessionId = null;
        }
        progress.measurable.forEach((measure) => {
          if (measure.id) {
            measure.id = null;
            measure.ptSessionTaskId = null;
          }
        });

        progress.assistance.forEach((assistance) => {
          if (assistance.id) {
            assistance.id = null;
            assistance.ptSessionTaskId = null;
          }
        });
      });
    }

    if (this.action === 'edit' && this.student.form.serviceInformation.ptSessionObjectives.length === 0) {
      this.addObjective();
    }
  },
  methods: {
    convertDisplayedDate(date) {
      const year = date.substring(0, 4);
      const month = date.substring(5, 7);
      const day = date.substring(8, 10);
      // eslint-disable-next-line
      return month + '/' + day + '/' + year;
    },
    getCurrentDate() {
      const testDate = new Date().toLocaleDateString('en-US', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
      return testDate;
    },
    calcDate() {
      if (!this.edited) {
        return this.convertDisplayedDate(this.student.form.serviceInformation.supervisorDate);
      } else {
        return this.getCurrentDate();
      }
    },
    addObjective() {
      const newObjective = {
        id: '',
        name: '',
        value: '',
        implementationOther: null
      };
      this.student.form.serviceInformation.ptSessionObjectiveImplementation.push([]);
      this.student.form.serviceInformation.ptSessionObjectives.push(newObjective);
    },
    addTask() {
      const newProgress = {
        id: null,
        task: '',
        measurable: [{
          ptSessionTaskId: '',
          type: 'OUT_OF',
          value1: '',
          value2: ''
        },
        {
          ptSessionTaskId: null,
          type: 'MINUTES',
          value1: ''
        },
        {
          ptSessionTaskId: null,
          type: 'ACCURACY',
          value1: ''
        }],
        assistance: [{
          ptSessionTaskId: null,
          type: 'OUT_OF',
          value1: '',
          value2: ''
        },
        {
          ptSessionTaskId: null,
          type: 'MINUTES',
          value1: ''
        },
        {
          ptSessionTaskId: null,
          type: 'PERCENT',
          value1: ''
        },
        {
          ptSessionTaskId: null,
          type: 'NONE',
          value1: ''
        }],
        type: [{
          ptSessionTaskId: null,
          id: null,
          code: 'PEER',
          assistType: 'Peer',
          checked: false
        },
        {
          ptSessionTaskId: null,
          id: null,
          code: 'ADULT',
          assistType: 'Adult',
          checked: false
        },
        {
          ptSessionTaskId: null,
          id: null,
          code: 'REMINDERS',
          assistType: 'Reminders',
          checked: false
        },
        {
          ptSessionTaskId: null,
          id: null,
          code: 'OTHER',
          assistType: '',
          checked: false
        },
      ]
      };
      this.student.form.serviceInformation.ptSessionProgresses.push(newProgress);
    },
    removeObjectiveRecord(index) {
      // Remove the objective and implementation at the given index
      this.student.form.serviceInformation.ptSessionObjectives.splice(index, 1);
      this.student.form.serviceInformation.ptSessionObjectiveImplementation.splice(index, 1);

      // Check if both arrays are empty after removal
      if (this.student.form.serviceInformation.ptSessionObjectives.length === 0) {
        // If both arrays are empty, reset them with empty objects
        this.student.form.serviceInformation.ptSessionObjectives = [{
          id: '',
          name: '',
          value: ''
        }];

        this.student.form.serviceInformation.ptSessionObjectiveImplementation = [{
          ptSessionObjectiveId: '',
          name: '',
          value: ''
        }];
      }
    },
    removeProgressRecord(index) {
      // Remove the progress at the given index
      this.student.form.serviceInformation.ptSessionProgresses.splice(index, 1);

      // Check if both arrays are empty after removal
      if (this.student.form.serviceInformation.ptSessionProgresses.length === 0) {
        // If both arrays are empty, reset them with empty objects
        this.student.form.serviceInformation.ptSessionProgresses = [{
          id: null,
          task: '',
          measurable: [{
            ptSessionTaskId: null,
            type: 'OUT_OF',
            value1: '',
            value2: ''
          },
          {
            ptSessionTaskId: null,
            type: 'MINUTES',
            value1: ''
          },
          {
            ptSessionTaskId: null,
            type: 'ACCURACY',
            value1: ''
          }],
          assistance: [{
            ptSessionTaskId: null,
            type: 'OUT_OF',
            value1: '',
            value2: ''
          },
          {
            ptSessionTaskId: null,
            type: 'MINUTES',
            value1: ''
          },
          {
            ptSessionTaskId: null,
            type: 'PERCENT',
            value1: ''
          },
          {
            ptSessionTaskId: null,
            type: 'NONE',
            value1: ''
          }],
          type: [{
            ptSessionTaskId: null,
            assistType: '',
            code: ''
          }]
        }]
      }
    },
    updateRecord(index, updatedRecord) {
      this.$set(this.combinedArray[index], 'ptSessionObjectives', { ...updatedRecord });
      this.student.form.serviceInformation.ptSessionObjectives[index] = { ...updatedRecord };
    },

    // Method to update the ptSessionObjectiveImplementation in combinedArray
    updateRecord2(index, updatedRecord) {
      this.$set(this.combinedArray[index], 'ptSessionObjectiveImplementation', updatedRecord );
      this.student.form.serviceInformation.ptSessionObjectiveImplementation[index] = updatedRecord;
    },
    emitRemoveRecordClicked() {
      Swal.fire({
        text: 'Are you sure you want to delete this record?',
        confirmButtonText: 'Delete',
        showCancelButton: true,
        customClass: {
          popup: 'popup-class',
          content: 'content-class',
          confirmButton: 'confirm-button-class delete'
        }
      }).then((response) => {
        if (response && response.value) this.$emit('delete:record', { index: this.index });
      });
    },
    remove(item) {
      this.record.objectives = this.record.objectives.filter((obj) => {
        return obj.objectiveDescription !== item;
      });
    },
    handleTextTrimming(field, value) {
      if (value !== null && value !== undefined) {
        const trimmed = value.trim();
        this.student.form.serviceInformation[field] = trimmed;
      }
    },
    handleTextTrimmingRequired(field, value) {
      this.v[field].$touch();
      if (value !== null && value !== undefined) {
        const trimmed = value.trim();
        this.student.form.serviceInformation[field] = trimmed;
      }
    },
    providerDisabled(){
      // check if provider info exists
      return !!this.student.form.serviceInformation.licenseAttestUserId;
    },
    supervisorCredentialFill(){
      if (this.student.form.serviceInformation.supervisorCredential !== undefined) {
        return this.student.form.serviceInformation.supervisorCredential;
      }
      else if (this.supervisorFlagsArray.supervisorCredential !== undefined) {
        return this.supervisorFlagsArray.supervisorCredential;
      }
      else {
        return '';
      }
    },
    onUserCheckboxClicked() {
      this.checkedCreate = true;
      this.checked = !this.checked;
      this.student.form.serviceInformation.licenseAttestUserId = JWTHelper.user().userId;
      this.student.form.serviceInformation.licenseAttestDate = moment().format('YYYY-MM-DD');
      this.student.form.serviceInformation.licenseAttestName = JWTHelper.user().fullName;
      this.disabledCopy = false;
    },
    onUserCheckboxClickedCopy() {
      this.student.form.serviceInformation.licenseAttestUserId = JWTHelper.user().userId;
      this.student.form.serviceInformation.licenseAttestDate = moment().format('YYYY-MM-DD');
      this.student.form.serviceInformation.licenseAttestName = JWTHelper.user().fullName;
      this.disabledCopy = true;
      this.providerCheckCopy = true;
      this.componentKey += 1;

      // null out supervisor attest info
      this.student.form.serviceInformation.supervisorUserId = null;
      this.student.form.serviceInformation.supervisorName = null;
      this.student.form.serviceInformation.supervisorCredential = null;
      this.student.form.serviceInformation.supervisorDate = null;
    },
    onSupervisorCheckboxClicked() {
      this.supervisorChecked = !this.supervisorChecked;
      this.student.form.serviceInformation.supervisorUserId = JWTHelper.user().userId;
      this.student.form.serviceInformation.supervisorName = JWTHelper.user().fullName;
      this.student.form.serviceInformation.supervisorCredential = JWTHelper.user().credentialName;
      this.student.form.serviceInformation.supervisorDate = moment().format('YYYY-MM-DD');
      this.disabled2 = true;
    },
    onSupervisorCheckboxClicked2() {
      this.supervisorChecked2 = !this.supervisorChecked2;
      this.student.form.serviceInformation.supervisorUserId = JWTHelper.user().userId;
      this.student.form.serviceInformation.supervisorName = JWTHelper.user().fullName;
      this.student.form.serviceInformation.supervisorCredential = JWTHelper.user().credentialName;
      this.student.form.serviceInformation.supervisorDate = moment().format('YYYY-MM-DD');
      this.disabled = true;
    }
  },
  watch: {
    'student.form.serviceInformation.licenseAttestUserId': {
      handler() {
        if (this.student.form.serviceInformation.licenseAttestUserId === null) {
          this.checkedCreate = false;
          this.checked = true;
          this.disabledCopy = false;
          this.providerCheckCopy = false;
        }
      }
    },
    'student.form.serviceInformation.supervisorUserId': {
      handler() {
        if (this.student.form.serviceInformation.supervisorUserId === null) {
          this.supervisorChecked = false;
          this.supervisorChecked2 = false;
          this.disabled = false;
          this.disabled2 = false;
          this.edited = true;
        }
      }
    },
    'student.form.serviceInformation.absentType': {
      handler() {
        if ((this.student.form.serviceInformation.absentType === null || this.student.form.serviceInformation.absentType === undefined) && !this.student.form.serviceInformation.ptSessionObjectives) {
          this.addObjective();
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped />



// WEBPACK FOOTER //
// src/components/service-log/form/extended-service-information.vue